"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _permission = require("@/mixins/permission/permission");

var _loading = require("@/mixins/loading/loading");

var _railway = require("@/mixins/railway/railway");

var _elementUi = require("element-ui");

var _countdown = _interopRequireDefault(require("@/components/countdown/countdown.vue"));

var _locationTimeline = _interopRequireDefault(require("@/views/railway/components/location-timeline/location-timeline.vue"));

var _moment = _interopRequireDefault(require("moment"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RailwayMainDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(RailwayMainDashboardComponent, _Mixins);

  var _super = _createSuper(RailwayMainDashboardComponent);

  function RailwayMainDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, RailwayMainDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.today = (0, _moment.default)(new Date()).format('YYYY-MM-DD');
    _this.refreshTime = 30;
    _this.orderData = [];
    _this.orderInfo = [];
    _this.planId = null;
    _this.provideGetOrderInfo = _this.getOrderInfo;
    return _this;
  }

  (0, _createClass2.default)(RailwayMainDashboardComponent, [{
    key: "onFSChanges",
    value: function onFSChanges(newVal) {}
    /*@Watch('planIds')
    onPlanIdsChanges(newVal) {
    }*/

  }, {
    key: "containerStyles",
    get: function get() {
      return {};
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {}
  }, {
    key: "created",
    value: function () {
      var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.refreshTime = parseInt(this.helper.get(this.$userSetting, 'default18', 30), 10);
                this.planId = this.planIds[0];

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var countdownEl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                countdownEl = this.helper.get(this.$refs, 'countdown', null);

                if (!countdownEl) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return this.getData(this.planId);

              case 4:
                countdownEl.startTimer();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }() // hacked should use socket

  }, {
    key: "handleCountdownZero",
    value: function () {
      var _handleCountdownZero = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getData(this.planId);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleCountdownZero() {
        return _handleCountdownZero.apply(this, arguments);
      }

      return handleCountdownZero;
    }()
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var planId,
            res,
            message,
            orderData,
            orderIds,
            res2,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                planId = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';

                if (!(this.helper.isUndefined(planId) && this.helper.isUndefined(this.planId))) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                this.loading = true;
                _context4.next = 6;
                return this.railwayAPI.getPlan({
                  status: 'active',
                  planId: planId
                });

              case 6:
                res = _context4.sent;
                message = {
                  title: this.$i18n.t('general.getSuccess'),
                  duration: 5000
                };

                if (!(this.helper.isUndefined(res) || res.failed)) {
                  _context4.next = 13;
                  break;
                }

                message.title = this.$i18n.t('general.getFailed');

                _elementUi.Notification.error(message);

                this.loading = false;
                return _context4.abrupt("return");

              case 13:
                // Notification.success(message);
                orderData = this.helper.get(res, 'data', []);
                orderIds = this.helper.flatten(orderData.map(function (o) {
                  return o['orderId'];
                }));
                this.logger.info('Railway Data', orderData);
                _context4.next = 18;
                return this.railwayAPI.getOrdersInPlan({
                  code: '',
                  orderId: orderIds
                });

              case 18:
                res2 = _context4.sent;
                this.orderData = (0, _toConsumableArray2.default)(orderData);
                this.orderInfo = this.helper.get(res2, 'data.orders', []);
                this.loading = false;

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "handlePlanIdChange",
    value: function () {
      var _handlePlanIdChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(planId) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getData(planId);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handlePlanIdChange(_x) {
        return _handlePlanIdChange.apply(this, arguments);
      }

      return handlePlanIdChange;
    }()
  }, {
    key: "getOrderInfo",
    value: function getOrderInfo(orderId, fieldName) {
      if (!this.orderInfo.length) {
        return null;
      }

      var obj = this.orderInfo.find(function (o) {
        return o['id'] === orderId;
      });

      if (this.helper.isUndefined(obj)) {
        return null;
      }

      return obj[fieldName];
    }
  }]);
  return RailwayMainDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _railway.RailwayMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], RailwayMainDashboardComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], RailwayMainDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], RailwayMainDashboardComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], RailwayMainDashboardComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.ProvideReactive)('getOrderInfo')], RailwayMainDashboardComponent.prototype, "provideGetOrderInfo", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$isFullscreen')], RailwayMainDashboardComponent.prototype, "onFSChanges", null);
RailwayMainDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'RailwayMainDashboardComponent',
  components: {
    'countdown': _countdown.default,
    'location-timeline': _locationTimeline.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem
  }
})], RailwayMainDashboardComponent);
var _default = RailwayMainDashboardComponent;
exports.default = _default;